import React, { useState, useEffect } from 'react';
import { Link, useHistory } from "react-router-dom";
import "./Navbar.css";
import { navItems, nosotros, productos, soporte } from "./NavItems";
import Dropdown from "./Dropdown";
import icono from './3lineas.svg'
import {
  home,
  login,
  ttLogo,
  store, close
} from './iconosNavbar/imagenesNavbar'
import useWindowDimensions from '../../../hooks/ScreenSizes/sizes'
import PopUpLogin from '../PopUps/PopUpLogin/index'
import { useSelector, useDispatch } from 'react-redux';
import {
  setToken,
  setUsuario,
  setConfiguracion,
  setFechasFiltro
} from '../../../redux/actions/loginAction';
import {
  agregarAlCarritoRedux,
  setCarrito,
  agregarProducto, agregarArticuloRedux, modificarProductoRedux
} from '../../../redux/actions/carritoActions';
import { CardMembershipTwoTone } from '@material-ui/icons';
import PopUpAlert from '../PopUps/PopUpAlerta';
import { getCarrito } from '../../../Querys/Carrito';
import Carrito from '../Carrito';
import Encriptar from '@renedelangel/helpers/lib/Encriptar';
import {
  redes01,
  redes02,
  redes03,
  redes04
} from '../FooterPagina2/Footer/logos';


function Navbar(props) {


  let { auxCarrito } = props;
  let seed = 'c29mdHdvbmVAc2VndW1leA=='
  const [tokenValido, setTokenValido] = useState(null);
  const { usuario, token } = useSelector(state => state.login);
  const dispatch = useDispatch();
  const setTokenRedux = (token) => dispatch(setToken(token));
  const history = useHistory();
  const pageWidth = useWindowDimensions().width;
  const setUsuarioRedux = usuario => {
    dispatch(setUsuario(usuario));
  };
  const agregarItemRedux = (item) => dispatch(agregarArticuloRedux(item));
  const modificarItemRedux = (item) => dispatch(modificarProductoRedux(item));
  const { carrito } = useSelector(state => state.carrito);
  const setCarritoRedux = (carritoUsuario) => dispatch(setCarrito(carritoUsuario));
  if (!carrito) {
    setCarritoRedux([]);
  }


  let pathname = window.location.pathname;

  const [dropdownNosotros, setDropdownNosotros] = useState(false);
  const [dropdownProductos, setDropdownProductos] = useState(false);
  /*  const [dropdownServicios, setDropdownServicios] = useState(false); */
  const [dropdownSoporte, setDropdownSoporte] = useState(false);
  const [dropdownNosotrosMobil, setDropdownNosotrosMobil] = useState(false);
  const [dropdownProductosMobil, setDropdownProductosMobil] = useState(false);
  const [dropdownServiciosMobil, setDropdownServiciosMobil] = useState(false);
  const [dropdownSoporteMobil, setDropdownSoporteMobil] = useState(false);
  const [openMenu, setOpenMenu] = useState(false);
  const [openLogin, setOpenLogin] = useState(false);
  const [openCuenta, setOpenCuenta] = useState(false);
  const [openAlert, setOpenAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState({
    titulo: '',
    mensaje: ''
  })

  const [shoppingCart, setShoppingCart] = useState([]);

  const [carritoShow, setCarritoShow] = useState(false);

  const [responsive, setResponsive] = useState(false);

  const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));


  useEffect(() => {
    function redirect() {

      if (pathname == '/a.php') {
        let newUrl
        if (window.location.protocol == 'https:') {
          newUrl = window.location.href.replace('https://www.', 'https://requicorreo.');
        }
        else {
          newUrl = window.location.href.replace('http://www.', 'https://requicorreo.');
        }
        /* console.log('newUrl', newUrl) */
        window.open(newUrl, '_self')
      }
    }
    redirect();
  }
    , [])


  function renderLogin(openLogin) {
    if (openLogin == false) {
      return (<></>)
    }
    else if (openLogin == true && usuario?.estatus !== 1) {
      return (<PopUpLogin
        loginOpen={setOpenLogin}
        propsSetOpenAlert={setOpenAlert}
        propsSetAlert={setAlertMessage}
      />);
    }
  }

  const routeChange = () => {
    let path = `/login`;
    history.push(path);
  }

  const routeAdminPanel = () => {
    let path = `/panelDeUsuario/${token}`;
    history.push(path);
    window.location.reload();
  }

  const routeShoppingCart = () => {
    let path = `/shoppingCart/${token}`;
    history.push(path);
    window.location.reload();
  }

  async function handleLogout() {
    try {
      setOpenLogin(false);
      setAlertMessage({
        titulo: '¡Hasta pronto!',
        mensaje: 'Ha cerrado sesión de forma exitosa'
      });
      setOpenAlert(true);
      await delay(3000);
      setTokenRedux(null);
      setUsuarioRedux(null);
      localStorage.clear();

    }
    catch ({ }) {
      setAlertMessage({
        titulo: 'Error',
        mensaje: 'No se ha podido cerrar la sesión, intente de nuevo'
      });
      setOpenAlert(true);
    }
    window.location.reload()
  }

  useEffect(() => {
    async function ftEffect() {
      if (token !== null) {
        let tokenValido = Encriptar.ValidarToken({ token, seed })
        if (usuario?.estatus == 1 && tokenValido) {
          let aux = await getCarrito({ usuarioID: usuario.usuarioID }, token)

          setShoppingCart(aux.listado);

        } else if (!tokenValido) {
          setAlertMessage({
            titulo: '¡Hasta pronto!',
            mensaje: 'Su sesión ha expirado'
          });
          setOpenAlert(true);
          await delay(3000);
          setTokenRedux(null);
          setUsuarioRedux(null);
          localStorage.clear();
          window.location.reload()
        }
      }
    }
    ftEffect();
  }, [auxCarrito, carrito, usuario, token])

  useEffect(() => {
    async function ftHandleCerrarResponsive() {
      if (responsive == false && pageWidth <= 768) {
        {
          setResponsive(true)
        }
      }
      if (responsive == true && pageWidth > 768) {
        setResponsive(false)
        setOpenMenu(false);
      }
    }
    ftHandleCerrarResponsive();
  }, [pageWidth])

  return (
    <>
      <nav className="navbar">
        <div className='navbarInterno'>
          <div className='iconoAbrir'
            onClick={() => { { openMenu ? setOpenMenu(false) : setOpenMenu(true); setDropdownNosotrosMobil(false); setDropdownProductosMobil(false); setDropdownSoporteMobil(false) } }}>
            <img src={icono} styles={{ width: '50px', height: '50px', backgroundColor: 'rgb(9,78,195)' }} />
          </div>
          <Link to="/">
            <div className='logoNavBar'>
              <img src={ttLogo} />
            </div>
          </Link>
          <ul className="nav-items">
            {navItems.map((item) => {

              switch (item.title) {
                case ('Nosotros'):
                  return (
                    <li
                      key={item.id}
                      className={item.cName}
                      onMouseEnter={() => setDropdownNosotros(true)}
                      onMouseLeave={() => setDropdownNosotros(false)}
                    >
                      <Link to={item.path}>{item.title}</Link>
                      {dropdownNosotros && <Dropdown submenus={nosotros} />}
                    </li>
                  );
                case ('Productos'):
                  return (
                    <li
                      key={item.id}
                      className={item.cName}
                      onMouseEnter={() => setDropdownProductos(true)}
                      onMouseLeave={() => setDropdownProductos(false)}
                    >
                      <Link to={item.path}>{item.title}</Link>
                      {dropdownProductos && <Dropdown submenus={productos} />}
                    </li>
                  );
                /*  case ('Servicios'):
                   return (
                     <li
                       key={item.id}
                       className={item.cName}
                       onMouseEnter={() => setDropdownServicios(true)}
                       onMouseLeave={() => setDropdownServicios(false)}
                     >
                       <Link to={item.path}>{item.title}</Link>
                       {dropdownServicios && <Dropdown submenus={servicios} />}
                     </li>
                   ); */
                case ('Soporte'):
                  return (
                    <li
                      key={item.id}
                      className={item.cName}
                      onMouseEnter={() => setDropdownSoporte(true)}
                      onMouseLeave={() => setDropdownSoporte(false)}
                    >
                      <Link to={item.path}>{item.title}</Link>
                      {dropdownSoporte && <Dropdown submenus={soporte} />}
                    </li>
                  );
                case ('Blog'):
                  return (
                    <li
                      key={item.id}
                      className={item.cName}
                    >
                      <Link to={item.path}>{item.title}</Link>
                    </li>);
                default:
                  return (null);
              }

            })}
          </ul>
          <div className='iconosNavBar' style={{ display: 'none' }}>
            <div className='listadoTienda' onMouseEnter={() => { usuario?.estatus == 1 && !responsive ? setCarritoShow(true) : setCarritoShow(false) }} onMouseLeave={() => { setCarritoShow(false) }} onClick={() => { if (usuario?.estatus == 1) { routeShoppingCart() } else { return } }}>

              <div className='contenedorCarrito'>
                <img src={store} />
                {
                  <h6>{shoppingCart.length}</h6>
                }
              </div>
              <div className='previewCarrito' style={{ display: carritoShow ? 'flex' : 'none' }}>
                {<><Carrito registros={shoppingCart} /></>}
              </div>
            </div>


            {
              !responsive ?
                <div className='cuenta' onMouseEnter={() => { usuario?.estatus == 1 ? setOpenCuenta(true) : setOpenCuenta(false) }} onMouseLeave={() => { setOpenCuenta(false) }}>
                  <img src={login} onClick={() => { setOpenLogin(true) }} />
                  {usuario?.estatus == 1 ? <h6>{usuario.nombre.split(' ')[0]}</h6> : <></>}
                  <div className='listadoCuenta' style={{ display: openCuenta ? 'flex' : 'none' }}>
                    <ul>
                      <li onClick={() => { routeAdminPanel() }}>
                        Cuenta
                      </li>
                      <li onClick={() => { handleLogout() }}>
                        Cerrar sesión
                      </li>
                    </ul>
                  </div>
                </div>
                :
                <></>
            }


          </div>
          <div className="contenedorRedes">
            <div className="contenedorEnlacesRedes">
              {/* <li>
                <a href="tel:+528332138556">
                  <img src={redes04} />
                </a>
              </li> */}
              <li>
                <a href="mailto:ventas@tytsoftwaredemexico.com?Subject=Información%20TYT">
                  <img src={redes03} />
                </a>
              </li>
              <li>
                <a
                  href="https://www.facebook.com/profile.php?id=100069325536914"
                  target="_blank"
                >
                  <img src={redes01} />
                </a>
              </li>
              <li>
                <a
                  href="https://www.instagram.com/tyt.software/"
                  target="_blank"
                >
                  <img src={redes02} />
                </a>
              </li>


            </div>
          </div>
        </div>
      </nav>




      <ul className={openMenu ? "nav-itemsMobil" : "nav-itemsMobil-off"} onClick={() => { setOpenMenu(false) }}>
        <div className='fondoResponsive' onClick={(e) => { e.stopPropagation() }}>
          <li style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}> <img style={{ width: '30px', height: '30px', objectFit: 'contain' }} src={close} onClick={() => { setOpenMenu(false) }}></img></li>

          {
            navItems.map((item) => {

              switch (item.title) {
                case 'Nosotros':
                  return (
                    <li
                      key={item.id}
                      className={item.cName}
                      onClick={() => { dropdownNosotrosMobil ? setDropdownNosotrosMobil(false) : setDropdownNosotrosMobil(true); setDropdownProductosMobil(false); setDropdownSoporteMobil(false) }}
                    >
                      {item.title}
                      <ul className={dropdownNosotrosMobil ? "linksInternos" : "linksInternosOff"}>
                        <li><a className="itemLista" href="/aboutUs">Acerca de T&T</a></li>
                        {/*    <li><a className="itemLista" href="/contact">Contacto</a></li> */}</ul>
                    </li>
                  );

                case ('Productos'):
                  return (
                    <li
                      key={item.id}
                      className={item.cName}
                      onClick={() => { dropdownProductosMobil ? setDropdownProductosMobil(false) : setDropdownProductosMobil(true); setDropdownNosotrosMobil(false); setDropdownServiciosMobil(false); setDropdownSoporteMobil(false) }}
                    >
                      {item.title}
                      <ul className={dropdownProductosMobil ? "linksInternos" : "linksInternosOff"}>
                        <li><a className="itemLista" href="/ttERP">T&T ERP</a></li>
                        <li><a className="itemLista" href="/ttNomina">T&T Nómina</a></li>
                        <li><a className="itemLista" href="/ttCFDI">T&T CFDI</a></li>
                      </ul>
                    </li>
                  );
                /*  case ('Servicios'):
                   return (
                     <li
                       key={item.id}
                       className={item.cName}
                       onClick={() => { dropdownServiciosMobil ? setDropdownServiciosMobil(false) : setDropdownServiciosMobil(true); setDropdownNosotrosMobil(false); setDropdownProductosMobil(false); setDropdownSoporteMobil(false) }}
                     >
                       {item.title}
                       <ul className={dropdownServiciosMobil ? "linksInternos" : "linksInternosOff"}>
                         <li><a className="itemLista" href="/services#consultoria">Consultoria</a></li>
                         <li><a className="itemLista" href="/webDevelopment">Desarrollo Web</a></li>
                         <li><a className="itemLista" href="/webDesign">Diseño Web</a></li>
                         <li><a className="itemLista" href="/appDevelopment">Desarrollo de aplicaciones</a></li>
                         <li><a className="itemLista" href="https://mkt.softwone.com" target='_blank'>Marketing Digital</a></li></ul>
                     </li>
                   ); */
                case ('Soporte'):
                  return (
                    <li
                      key={item.id}
                      className={item.cName}
                      onClick={() => { dropdownSoporteMobil ? setDropdownSoporteMobil(false) : setDropdownSoporteMobil(true); setDropdownProductosMobil(false); setDropdownNosotrosMobil(false); setDropdownServiciosMobil(false); }}
                    >
                      {item.title}
                      <ul className={dropdownSoporteMobil ? "linksInternos" : "linksInternosOff"}>
                        <li><a className="itemLista" href="/onlineAssistant">Asistente en linea</a></li>
                      </ul>
                    </li>
                  );
                case ('Blog'):
                  return (
                    <li
                      key={item.id}
                      className={item.cName}
                    >
                      <Link className='alone' to={item.path}>{item.title}</Link>
                    </li>);
                default:
                  return (null)
              }
            }
            )
          }
          {/* <>{usuario?.estatus == 1 ? <li className='nav-item'>{ <a className='alone' href={`/panelDeUsuario/${token}`}>Ver cuenta</a>}</li> : <></>}</>
          <>{usuario?.estatus == 1 ? <li className='nav-item'>{ <a className='alone' onClick={() => { handleLogout() }}>Cerrar sesion</a>}</li> : <></>}</>
          <>{usuario?.estatus !== 1 ? <li className='nav-item'>{ <a className='alone' onClick={()=>{setOpenLogin(true)}}>Iniciar sesión</a>}</li> : <></>}</> */}
        </div>
      </ul>

      <div style={{ width: '100%', height: '100%' }}>{renderLogin(openLogin)}</div>

      {openAlert ? <PopUpAlert titulo={alertMessage.titulo} mensaje={alertMessage.mensaje} open={setOpenAlert} /> : <></>}
    </>
  );
}

export default Navbar;
